import React, { useEffect, useState, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import { subscribe } from "../utils/pubsub"
import Spinner from "../ui-elements/Spinner"
import Button from '../formfields/Button'
import Text from '../formfields-new/Text'
import RedAlert from '../ui-elements/RedAlert'
import Modal from '../ui-elements/Modal'
import { useNavigate, useParams } from 'react-router-dom'
import Password from '../formfields-new/Password'
import { getOrCreateUniqueDeviceId } from '../utils/uniqueDeviceId'

type Props = {

}


function ExternalUserLoginForm({

}: Props) {

    const {
        tableData,
        setShowModal,
        sendMessageToWebsocket,
        currentOrganisation,
        orgIdFromQrCode,
        loggedIn,
        connectionState,
        t,
        getUserStats
    } = useContext(GlobalContext)

    const { checklistId } = useParams()
    const navigate = useNavigate()
    const initialFormData = { "UserName": { "value": '', "required": true, "type": "text" } }
    const [formFields, setFormFields] = useState<ObjectStringKeyAnyValue>(initialFormData)
    const [errorMessage, setErrorMessage] = useState<string>('')

    // turn off modal on unmount 
    useEffect(() => {
        return () => {
            setShowModal(null)
        }
    }, [])
    

    const validate = () => {
        let isValid = true
        let errorMessage = ''

        if (!checklistId || checklistId.trim() === '') {
            isValid = false
            errorMessage = `${errorMessage} ${t('Auth.ExternalUserLoginForm.checklistIdMissing')} `
        }

        if (
            !formFields["UserName"]['value'] ||
            formFields["UserName"]['value'].trim() === ''
        ) {
            isValid = false
            errorMessage = `${errorMessage} ${t('Auth.ExternalUserLoginForm.pleaseEnterName')} `
        }

        setErrorMessage(errorMessage)
        return isValid
    }


    const validateAndSave = () => {
        const isValid = validate()
        if (isValid) {
            setErrorMessage('')
            setShowModal({ "spinner": t('Auth.ExternalUserLoginForm.loggingYouIn') })
            const payload: ObjectStringKeyAnyValue = {
                action: 'guestLogin',
                guestLoginAction: 'externalIndividualLogin',
                lookupType: 'checklist_id',
                checklistId: checklistId,
                "UserName": `${formFields['UserName'].value}`,
                "OrganisationId": `${orgIdFromQrCode ? orgIdFromQrCode : currentOrganisation}`,
                uniqueDeviceId: getOrCreateUniqueDeviceId(),
                userStats: getUserStats()
            }
            const trialSessionId = new URLSearchParams(window.location.search).get('trialSessionId')
            if (trialSessionId) {
                payload['trialSessionId'] = trialSessionId
            }
            sendMessageToWebsocket(JSON.stringify(payload))
        } 
    }



    return <div className={`w-full flex flex-col gap-4`}>

        {/* <h3 className={`font-righteous text-2xl`}> External guest log in</h3> */}

        <div className={`flex flex-col gap-2`}>
            <p>
                {t('Auth.ExternalUserLoginForm.whatIsYourFullName')}
            </p>
            {/* {loggedIn?"logged in":"not logged in"} {connectionState} */}
            <Text
                labelText={''}
                formFields={formFields}
                setFormFields={setFormFields}
                fieldName={'UserName'}
                placeholder={''}
                errorMessage={t('Auth.ExternalUserLoginForm.pleaseEnterFullName')}
                size={'big'}
                center={true}
                value={formFields && formFields['UserName'] && formFields['UserName'].value || ''}
            />
        </div>

        {errorMessage && <RedAlert>{errorMessage}</RedAlert>}

        <div className={`w-full flex flex-row gap-4`}>
            <Button
                onClick={validateAndSave}
                text={t('Buttons.next')}
                variant={'secondary'}
                size={'big'}
                sameWindow={true}
                id={'continueButton'}
            />
        </div>
    </div>
}
export default ExternalUserLoginForm